export enum RoutesKeys {
  HOME = 'home',
  CALLBACK = 'callback',
  ACCOUNT_SETTINGS = 'account-settings',
  ADD_BUSINESS_UNIFICATION = 'add-business-unification',
  BUSINESS_UNIFICATION = 'business-unification',
  SYSTEM_SETTINGS = 'system-settings',
  BUSINESS_LIST = 'business-list',
  ONBOARDING = 'onboarding',
  LOGIN_CALLBACK = 'login/callback',
  LOGOUT = 'logout',
  UPLOAD = 'upload',
  CUSTOMER_DETAIL = 'customer-detail',
  REWARDS = 'rewards',
  CONTROL_PANEL = 'control-panel',
  DOWNLOAD_REPORTS = 'download-reports',
  PRODUCT_DETAIL = 'product-detail',
  REWARD_DETAIL = 'reward-detail',
  COUPONS_VIP = 'coupons-vip',
  VIP_SETTINGS_DETAIL = 'vip-detail',
}
